import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ModalService } from '../../../utils/modal.service';
import { ToastService } from '../../../utils/toast.service';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule,NgOptimizedImage],
  templateUrl: './modal.component.html'
})

export class ModalComponent {
  @Input() imageUrl: string = '';
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() cancelButtonText: string = 'Cancelar';
  @Input() continueButtonText: string = 'Continuar';


  @Input() showCancelButton: boolean = false;
  @Output() close = new EventEmitter<void>();

  modalService = inject(ModalService);
  toastService = inject(ToastService)

  modalVisible = this.modalService.modalVisible;





  onClose(){
    this.modalService.closeModal();
  }

  onConfirmClick() {
    if (this.modalService.onConfirm) {
      this.modalService.onConfirm();
    }
    this.modalService.closeModal();

    if (this.modalService.showToastOnConfirm()) {
      this.toastService.showToast(
        'fi fi-ss-check-circle text-[24px] text-[#17BF33]',
        'Estado actualizado de manera exitosa',
        'success'
      );
    }
  }


  
}
